import HoursGrid from 'components/Content/Happening/StoreDetails/HoursInformation/HoursGrid/HoursGrid';

export default HoursGrid;
